module.exports = __webpack_public_path__ + "static/media/247-somaliland.6ecbb72f.svg";